<template>
    <section>
    <div>
        
          <span class="is-pulled-right">

            <span class="is-pulled-left" v-if="isTraining()">
             <b-tooltip type="is-dark" position="is-bottom" multilined>
                <b-button label="A" style="margin-right:1em;border: 0;" size="is-mediumx" v-if="isTraining()" :loading="isTraining()"></b-button>
                <template v-slot:content>
                   <b>🧠 This model is training in background</b>
                </template>
             </b-tooltip>
          </span>            
                <b-dropdown aria-role="list" :triggers="['hover']">
                    <template #trigger>
                        <b-taglist attached>
                        <b-tag role="button" size="is-large" type="is-info is-light">{{ project.type | capitalize }}</b-tag>
                    </b-taglist>
                    </template>
                </b-dropdown>&nbsp;
                
                <b-tooltip type="is-dark" position="is-bottom" multilined>
                <b-button
                        v-if="hasEnoughCredits()"
                        @click="create()"
                        type="is-info">
                        <i class="fa fa-brain"></i>&nbsp;&nbsp;Train
                </b-button>
                <b-button
                        v-else
                        tag="router-link"
                        :to="'/d/pricing'"
                        type="is-info">
                        <i class="fa fa-brain"></i>&nbsp;&nbsp;Train
                </b-button>
                <template v-slot:content>
                    <span v-if="isTraining()">
                        Already exists a training in progress
                    </span>
                    <span v-else-if="!hasEnoughCredits()">
                        No enough credits to train this model. Need {{ creditsNeeded() }} credits
                    </span>
                    <span v-else>
                        This training will cost {{ creditsNeeded() }} credits
                    </span>
                </template>
                </b-tooltip>

                <b-dropdown position="is-bottom-left" aria-role="list" :triggers="['click']" style="margin-left: -0.5em">
                    <template #trigger="{ active }">
                <b-field position="is-left">
            
            <p class="control">
                
                <b-button
                        type="is-info">
                        <i v-if="active" class="fa fa-chevron-up fa-2xs"></i>
                        <i v-else class="fa fa-chevron-down fa-2xs"></i>
                    </b-button>
            </p>
                </b-field>
                </template>
                <b-dropdown-item aria-role="listitem" @click="openNewModel()">
                    Train with custom parameters
                </b-dropdown-item>
            </b-dropdown>
            &nbsp;
            <b-tooltip type="is-dark" position="is-left" multilined>
            <b-button v-if="stepId == 'train'" @click="showModels()" :type="!this.viewModels ?'is-info is-light':'is-info'">
                <i class="fa fa-list"></i>&nbsp;&nbsp;Models
            </b-button>
            <template v-slot:content>
                   View your model's training report and see how well your model performed
                </template>
            </b-tooltip>
        </span>
    </div>
    
       <b-modal
          v-model="isModalNewModelOpen"
          has-modal-card
          trap-focus
          :destroy-on-hide="true"
          aria-role="dialog"
          aria-label="Project"
          aria-modal  
          can-cancel
          scroll="keep">
          <template #default="props">
             <ModelCreate @close="props.close" :project="project" :rowsLength="rowsLength" :currentUser="currentUser"></ModelCreate>
          </template>
       </b-modal>
       
    </section>
 </template>
 <script>
 
    import ModelCreate from "@/components/ModelCreate.vue";
    import mixin from '@/utils/sharedFunctions.js'

export default {
         mixins: [mixin],
         props: ["header", "project", "currentUser", "metrics", "rowsLength", "stepId"],
         name: "TrainHeader",
         data: function() {
            return {
                textIsTrainingBackground: 'This model is training in background',
                textIsTrainingTag: 'Training',
                textIsTrainTag: 'Train',
                textIsTrainedTag: 'trained',
                isLoading: true,
                isModalTrainingMetricsOpen: false,
                isModalNewModelOpen: false,
                justTriggedTraining: false
            }
        },
        components: {
            ModelCreate
        },
        filters: {
            capitalize: function (value) {
              if (!value) return ''
              value = value.toString()
              return value.charAt(0).toUpperCase() + value.slice(1)
            }
        },
        computed:{
            viewModels(){
                return this.$store.state.viewModels || false
            },
        },
        created(){
            
        },
         methods: {
            openNewModel(){
                if (this.hasEnoughCredits()){
                    this.isModalNewModelOpen = true
                } else {
                    this.$router.push('/d/pricing')
                }
            },
          showModels(){
            this.$store.dispatch("showViewModels", !this.viewModels)
          },
          isTraining(){
            let hasStatus = Object.hasOwn(this.project, 'state') && Object.hasOwn(this.project.state, 'train')
            let status = hasStatus ? this.project.state.train.status : false
            if (hasStatus && ['running', 'queued', 'pending'].includes(status)){
                this.justTriggedTraining = false
                return true
            } if (this.justTriggedTraining){
                return true
            } else {
                return false
            }
          }
         }
       }
 </script>
 <style>
    .self-building-square-spinner, .self-building-square-spinner * {
    box-sizing: border-box;
    }
    .self-building-square-spinner {
    height: 40px;
    width: 40px;
    top: calc( -10px * 2 / 3);
    }
    .self-building-square-spinner .square {
    height: 10px;
    width: 10px;
    top: calc( -10px * 2 / 3);
    margin-right: calc(10px / 3);
    margin-top: calc(10px / 3);
    background: #3482F6;
    float: left;
    position:relative;
    opacity: 0;
    animation: self-building-square-spinner 6s infinite;
    }
    .self-building-square-spinner .square:nth-child(1) {
    animation-delay: calc(300ms * 6);
    }
    .self-building-square-spinner .square:nth-child(2) {
    animation-delay: calc(300ms * 7);
    }
    .self-building-square-spinner .square:nth-child(3) {
    animation-delay: calc(300ms * 8);
    }
    .self-building-square-spinner .square:nth-child(4) {
    animation-delay: calc(300ms * 3);
    }
    .self-building-square-spinner .square:nth-child(5) {
    animation-delay: calc(300ms * 4);
    }
    .self-building-square-spinner .square:nth-child(6) {
    animation-delay: calc(300ms * 5);
    }
    .self-building-square-spinner .square:nth-child(7) {
    animation-delay: calc(300ms * 0);
    }
    .self-building-square-spinner .square:nth-child(8) {
    animation-delay: calc(300ms * 1);
    }
    .self-building-square-spinner .square:nth-child(9) {
    animation-delay: calc(300ms * 2);
    }
    .self-building-square-spinner .clear{
    clear: both;
    }
    @keyframes self-building-square-spinner {
    0% {
    opacity: 0;
    }
    5% {
    opacity: 1;
    top: 0;
    }
    50.9% {
    opacity: 1;
    top: 0;
    }
    55.9% {
    opacity: 0;
    top: inherit;
    }
    }
 </style>